import React from 'react';
import './logo.css';

const Logo = ({ logoUrl }) => (
  <img className="logo" src={logoUrl} alt="Logo" />
);

export default Logo;
